import React from 'react'
import { Route } from 'react-router-dom'
import { AuthRouteElement, AuthRouteProps, UserState } from '@percent/cause-dashboard/common/components/route/AuthRoute'

// Helper function to create Route elements with AuthRouteElement
// This ensures React Router v6 recognizes them as Route components
export const createAuthRoute = (path: string, props: Omit<AuthRouteProps, 'path'>): React.ReactElement => {
  return (
    <Route
      path={path}
      element={
        <AuthRouteElement
          allow={props.allow}
          disallow={props.disallow}
          feature={props.feature}
          component={props.component}
        >
          {props.children}
        </AuthRouteElement>
      }
    />
  )
}
